import { I18nComponente } from "@/types/gerais"

export const OAtributosAlocacaoUsuarioi18n: I18nComponente = {
  "pt-BR": {
    esteUsuarioNaoPossuiUm: "Este usuário não possui um",
    profissionalAssociado: "profissional associado",
    criarProfissional: "criar profissional",
  },
  "es-CO": {
    esteUsuarioNaoPossuiUm: "Este usuario no tiene un",
    profissionalAssociado: "profesional asociado",
    criarProfissional: "añadir profesional",
  }
}
